import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/educacao/receitas/form_cad'


function CadastrarReceitaEducacaoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Receita da Secretaria Municipal de Educação" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarReceitaEducacaoScreen;